// extracted by mini-css-extract-plugin
export default {"policy":"Acceptance_policy__0Wh6e","wrapper":"Acceptance_wrapper__vWbsg","addr":"Acceptance_addr__W0uMg","points":"Acceptance_points__DkqR9","rules":"Acceptance_rules__HKQD4"};